/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Toast_TitleInputs */

const en_signin_toast_title = /** @type {(inputs: Signin_Toast_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign-in is not connected yet`)
};

/** @type {(inputs: Signin_Toast_TitleInputs) => LocalizedString} */
const ar_signin_toast_title = en_signin_toast_title;

/** @type {(inputs: Signin_Toast_TitleInputs) => LocalizedString} */
const he_signin_toast_title = en_signin_toast_title;

/** @type {(inputs: Signin_Toast_TitleInputs) => LocalizedString} */
const ur_signin_toast_title = en_signin_toast_title;

/** @type {(inputs: Signin_Toast_TitleInputs) => LocalizedString} */
const es_signin_toast_title = en_signin_toast_title;

/** @type {(inputs: Signin_Toast_TitleInputs) => LocalizedString} */
const fr_signin_toast_title = en_signin_toast_title;

/** @type {(inputs: Signin_Toast_TitleInputs) => LocalizedString} */
const de_signin_toast_title = en_signin_toast_title;

/** @type {(inputs: Signin_Toast_TitleInputs) => LocalizedString} */
const pt_signin_toast_title = en_signin_toast_title;

/** @type {(inputs: Signin_Toast_TitleInputs) => LocalizedString} */
const hi_signin_toast_title = en_signin_toast_title;

/** @type {(inputs: Signin_Toast_TitleInputs) => LocalizedString} */
const bn_signin_toast_title = en_signin_toast_title;

/**
* | output |
* | --- |
* | "Sign-in is not connected yet" |
*
* @param {Signin_Toast_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const signin_toast_title = /** @type {((inputs?: Signin_Toast_TitleInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Toast_TitleInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_signin_toast_title(inputs)
	if (locale === "he") return he_signin_toast_title(inputs)
	if (locale === "ur") return ur_signin_toast_title(inputs)
	if (locale === "es") return es_signin_toast_title(inputs)
	if (locale === "fr") return fr_signin_toast_title(inputs)
	if (locale === "de") return de_signin_toast_title(inputs)
	if (locale === "pt") return pt_signin_toast_title(inputs)
	if (locale === "hi") return hi_signin_toast_title(inputs)
	if (locale === "bn") return bn_signin_toast_title(inputs)
	return /** @type {LocalizedString} */ ("Sign-in is not connected yet")
});